import { Component, effect, ElementRef, inject, OnDestroy, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SendSayGoodByeEmail } from 'src/app/pages/custom-route/components/custom-route-desktop/services';
import { CustomRouteService } from 'src/app/pages/custom-route/services';

@Component({
  selector: 'app-say-good-bye-view',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './say-good-bye-view.component.html',
  styleUrls: ['./say-good-bye-view.component.scss'],
})
export class SayGoodByeViewComponent implements OnDestroy {
  public sayGoodByeRef = viewChild<ElementRef | null>('sayGoodByeViewRef');
  
  private _sendSayGoodByeEmailService = inject(SendSayGoodByeEmail);
  private _customRouteService = inject(CustomRouteService);
  
  protected isLoadingSendGoodByeEmail = this._sendSayGoodByeEmailService.isLoadingSendGoodByeEmail;
  private _routeToken = this._customRouteService.token;
  
  showGoodByeView = effect(() => {
    const ref = this.sayGoodByeRef();
    if (!ref) return;
    
    const el = ref.nativeElement as HTMLElement;
    if (this.isLoadingSendGoodByeEmail()) {
      el.classList.add('fade-in');
      
      this._sendSayGoodByeEmailService.sendMessageSayGoodByeByWS(this._routeToken());
    } 
  })
  
  ngOnDestroy(): void {
    this._sendSayGoodByeEmailService.clearTimeoutSendGoodBye();
    this._sendSayGoodByeEmailService.setIsLoadingSendGoodByeEmail(false);
  }
}
